import { MAX_PENDING_PLAY_REQUESTS } from 'constants/payloads/playRequests';
import { useGetMyPendingPlayRequestsQuery } from 'types/generated/client';
import { useViewer } from 'hooks/useViewer';

/**
 * How many more play requests the viewer may send before hitting the pending cap.
 * `null` until known. `cache-and-network` so reopening a modal reflects a request
 * just sent or resolved elsewhere.
 */
export function useRemainingPlayRequests({ skip = false }: { skip?: boolean } = {}) {
  const { userId } = useViewer();

  const { data, loading, refetch } = useGetMyPendingPlayRequestsQuery({
    variables: { userId: userId ?? '' },
    skip: skip || !userId,
    fetchPolicy: 'cache-and-network',
  });

  const pendingCount = data?.playRequests.length;

  return {
    remaining: pendingCount == null ? null : Math.max(0, MAX_PENDING_PLAY_REQUESTS - pendingCount),
    isLoading: loading,
    refetch,
  };
}
